{
  "Common": {
    "close": "Close",
    "closeAlert": "Close alert",
    "notifications": "Notifications",
    "newNotification": "New",
    "readStatus": "Read",
    "openLink": "Open link",
    "theme": "Theme",
    "lightTheme": "Light",
    "darkTheme": "Dark",
    "systemTheme": "System",
    "density": "Density",
    "compact": "Compact",
    "normal": "Normal",
    "comfortable": "Comfortable",
    "columns": "Columns",
    "loading": "Loading",
    "noData": "No data",
    "clearFilter": "Clear filter",
    "selectAll": "Select all",
    "default": "Default",
    "other": "Other",
    "headerAlign": "Header alignment",
    "alignLeft": "Align left",
    "alignCenter": "Align center",
    "alignRight": "Align right"
  },
  "ValidationInput": {
    "required": "This field is required",
    "typeMismatch": "Invalid format",
    "pattern": "Invalid pattern",
    "tooShort": "Too short",
    "tooLong": "Too long",
    "rangeUnderflow": "Below minimum",
    "rangeOverflow": "Above maximum",
    "stepMismatch": "Step mismatch",
    "badInput": "Bad input",
    "invalid": "Invalid value"
  },
  "Loading": {
    "loadingPage": "Loading page",
    "pleaseWait": "Please wait"
  },
  "DatePicker": {
    "placeholder": "Select date",
    "today": "Today",
    "clear": "Clear",
    "lunarFormat": "Month {month} {day}, {year}",
    "lunarLeapFormat": "Month {month} {day}, {year} (Leap)",
    "lunarMonth": "Month {month}",
    "lunarLeap": "Leap"
  },
  "DateTimePicker": {
    "time": "Time",
    "clear": "Clear",
    "done": "Done"
  },
  "CalendarTimeline": {
    "today": "Today",
    "prev": "Previous",
    "next": "Next",
    "month": "Month",
    "week": "Week",
    "day": "Day",
    "sprint": "Sprint",
    "newEvent": "New event",
    "createEventTitle": "Create event",
    "create": "Create",
    "cancel": "Cancel",
    "resource": "Resource",
    "start": "Start",
    "end": "End",
    "resourcesHeader": "Resources",
    "expandGroup": "Expand group",
    "collapseGroup": "Collapse group",
    "more": "+{n} more",
    "sprints": "{n} sprints",
    "deleteConfirm": "Delete?"
  },
  "Pagination": {
    "navigationLabel": "Pagination navigation",
    "showingResults": "Showing {startItem}–{endItem} of {totalItems}",
    "firstPage": "First page",
    "previousPage": "Previous page",
    "previous": "Previous",
    "nextPage": "Next page",
    "next": "Next",
    "lastPage": "Last page",
    "pageNumber": "Page {page}",
    "itemsPerPage": "Items per page",
    "search": "Search",
    "noOptions": "No options"
  },
  "OCR": {
    "imageUpload": {
      "dragDropText": "Drag & drop files here",
      "browseFiles": "Browse files",
      "supportedFormats": "Supported formats: images"
    }
  },
  "FileUpload": {
    "dragDropText": "Drag & drop files here",
    "browseFiles": "Browse files",
    "uploadFiles": "Upload files",
    "supportedFormats": "All file types supported",
    "uploadedFiles": "Uploaded files",
    "clearAll": "Clear all",
    "fileTooLarge": "exceeds size limit",
    "maxFilesReached": "Maximum file limit reached",
    "uploadSuccess": "uploaded successfully",
    "uploadFailed": "upload failed"
  },
  "UEditor": {
    "placeholder": "Type '/' for commands, or just start writing...",
    "loading": "Loading editor...",
    "words": "words",
    "characters": "characters",
    "colors": {
      "default": "Default",
      "muted": "Muted",
      "primary": "Primary",
      "secondary": "Secondary",
      "success": "Success",
      "warning": "Warning",
      "destructive": "Destructive",
      "info": "Info",
      "accent": "Accent",
      "textColor": "Text Color",
      "highlight": "Highlight",
      "automatic": "Automatic",
      "moreColors": "More Colors...",
      "color": "Color",
      "done": "Done"
    },
    "toolbar": {
      "bold": "Bold",
      "boldShortcut": "Bold (Ctrl+B)",
      "italic": "Italic",
      "italicShortcut": "Italic (Ctrl+I)",
      "underline": "Underline",
      "underlineShortcut": "Underline (Ctrl+U)",
      "strike": "Strikethrough",
      "code": "Inline Code",
      "subscript": "Subscript",
      "superscript": "Superscript",
      "link": "Link",
      "removeLink": "Remove Link",
      "image": "Insert Image",
      "table": "Insert Table",
      "alignment": "Alignment",
      "alignLeft": "Align Left",
      "alignCenter": "Align Center",
      "alignRight": "Align Right",
      "justify": "Justify",
      "bulletList": "Bullet List",
      "orderedList": "Numbered List",
      "taskList": "Task List",
      "quote": "Quote",
      "codeBlock": "Code Block",
      "undo": "Undo (Ctrl+Z)",
      "redo": "Redo (Ctrl+Y)",
      "textStyle": "Text Style",
      "fontFamily": "Font Family",
      "fontSize": "Font Size",
      "lineHeight": "Line Height",
      "fontDefault": "Default Font",
      "sizeDefault": "Default Size",
      "lineHeightDefault": "Default Leading",
      "letterSpacing": "Letter Spacing",
      "letterSpacingDefault": "Default Tracking",
      "fontSans": "Sans",
      "fontSerif": "Serif",
      "fontMono": "Mono",
      "normal": "Normal text",
      "heading1": "Heading 1",
      "heading2": "Heading 2",
      "heading3": "Heading 3",
      "emoji": "Insert Emoji",
      "imageLayoutBlock": "Image Block",
      "imageLayoutLeft": "Wrap Text Right",
      "imageLayoutRight": "Wrap Text Left",
      "imageWidthSm": "Image Width Small",
      "imageWidthMd": "Image Width Medium",
      "imageWidthLg": "Image Width Large",
      "imageResetSize": "Reset Image Size",
      "imageDelete": "Delete Image"
    },
    "slashCommand": {
      "basicBlocks": "Basic Blocks",
      "text": "Text",
      "textDesc": "Plain text block",
      "heading1": "Heading 1",
      "heading1Desc": "Large section heading",
      "heading2": "Heading 2",
      "heading2Desc": "Medium section heading",
      "heading3": "Heading 3",
      "heading3Desc": "Small section heading",
      "bulletList": "Bullet List",
      "bulletListDesc": "Simple bulleted list",
      "orderedList": "Numbered List",
      "orderedListDesc": "Numbered list",
      "todoList": "To-do List",
      "todoListDesc": "Checkboxes for tasks",
      "quote": "Quote",
      "quoteDesc": "Capture a quote",
      "codeBlock": "Code Block",
      "codeBlockDesc": "Code with syntax highlighting",
      "divider": "Divider",
      "dividerDesc": "Visual divider",
      "table": "Table",
      "tableDesc": "Add a table",
      "noResults": "No matching blocks found",
      "callout": "Callout",
      "calloutDesc": "Highlight key info with a callout block",
      "bookmark": "Bookmark Card",
      "bookmarkDesc": "Embed a link as a bookmark card",
      "fileCard": "File Attachment",
      "fileCardDesc": "Upload a file card attachment",
      "formCheckbox": "Form Checkbox",
      "formCheckboxDesc": "Insert an interactive checkbox field",
      "roundCheckbox": "Round Checkbox",
      "roundCheckboxDesc": "Insert a circular interactive checkbox",
      "formRadio": "Form Radio Button",
      "formRadioDesc": "Insert an interactive radio button field"
    },
    "floatingMenu": {
      "addBlock": "Add block"
    },
    "linkInput": {
      "placeholder": "Paste or type a link...",
      "invalid": "Enter a valid link, such as https://example.com."
    },
    "imageInput": {
      "urlTab": "URL",
      "uploadTab": "Upload",
      "urlLabel": "Image URL",
      "urlPlaceholder": "https://example.com/image.jpg",
      "uploadLabel": "Choose Image",
      "uploadPlaceholder": "Click to upload image",
      "uploading": "Uploading...",
      "uploadError": "Upload failed. Please try again.",
      "altLabel": "Alt text (optional)",
      "altPlaceholder": "Describe the image...",
      "addBtn": "Add Image",
      "cancelBtn": "Cancel",
      "addFromUrl": "Add from URL"
    },
    "emojiPicker": {
      "searchPlaceholder": "Search emoji",
      "noResults": "No emoji found",
      "tryDifferentSearch": "Try a different keyword"
    },
    "stickerPicker": {
      "searchPlaceholder": "Search stickers",
      "noResults": "No stickers found",
      "tryDifferentSearch": "Try a different keyword"
    },
    "emojiSuggestion": {
      "title": "Emoji",
      "noResults": "No emoji found",
      "showingCount": "Showing first {shown} of {total} emojis"
    },
    "formulaSuggestion": {
      "title": "Functions",
      "noResults": "No function found",
      "sum": "Add values in a range",
      "avg": "Average values in a range",
      "min": "Smallest value in a range",
      "max": "Largest value in a range",
      "count": "Count numeric cells in a range"
    },
    "tableMenu": {
      "insert3x3": "Insert 3×3 Table",
      "insertTable": "Insert Table",
      "gridPreview": "Insert {rows}×{cols} Table",
      "addColumnBefore": "Add Column Before",
      "addColumnAfter": "Add Column After",
      "addRowBefore": "Add Row Before",
      "addRowAfter": "Add Row After",
      "duplicateColumn": "Duplicate Column",
      "duplicateRow": "Duplicate Row",
      "clearColumnContents": "Clear Column Contents",
      "clearRowContents": "Clear Row Contents",
      "deleteColumn": "Delete Column",
      "deleteRow": "Delete Row",
      "deleteTable": "Delete Table",
      "toggleHeaderRow": "Toggle Header Row",
      "toggleHeaderColumn": "Toggle Header Column",
      "mergeCells": "Merge Cells",
      "splitCell": "Split Cell",
      "openControls": "Open Table Controls",
      "quickAddColumnAfter": "Quick Add Column After",
      "quickAddRowAfter": "Quick Add Row After",
      "expandTable": "Expand Table",
      "dragRow": "Drag Row",
      "dragColumn": "Drag Column",
      "alignLeft": "Align Table Left",
      "alignCenter": "Align Table Center",
      "alignRight": "Align Table Right",
      "cellBackground": "Cell Background",
      "cellBorder": "Cell Border",
      "borderStyle": "Border Style",
      "borderWidth": "Border Width",
      "borderColor": "Border Color",
      "clearBorder": "Clear Border",
      "formula": "Formula",
      "formulaBar": "Formula bar",
      "formulaError": "Formula error",
      "editFormula": "Edit formula",
      "clearCell": "Clear cell",
      "convertToValue": "Convert to value",
      "numberFormat": "Number Format",
      "formatText": "Text",
      "formatDate": "Date",
      "apply": "Apply",
      "clear": "Clear",
      "recalculate": "Recalculate",
      "done": "Done",
      "alignVertical": "Vertical Alignment",
      "alignVerticalTop": "Top Align",
      "alignVerticalMiddle": "Middle Align",
      "alignVerticalBottom": "Bottom Align",
      "textDirection": "Text Direction",
      "horizontalText": "Horizontal Text",
      "verticalText": "Vertical Text"
    },
    "callout": {
      "selectEmoji": "Select Emoji",
      "backgroundColor": "Background Color"
    },
    "radio": {
      "groupName": "Group Name",
      "editGroup": "Edit Group Name"
    },
    "bookmark": {
      "clickToOpenNewTab": "Click to open this link in a new tab.",
      "clickToOpenLink": "Click to open link.",
      "noDescription": "No description available.",
      "failedToLoad": "Failed to load link preview. Click to open link.",
      "previewFailed": "Preview failed to load",
      "retryPreview": "Retry preview"
    },
    "fileCard": {
      "unnamed": "Unnamed file",
      "uploading": "(Uploading...)",
      "uploadFailed": "Upload failed",
      "retryUpload": "Retry upload"
    },
    "menubar": {
      "file": "File",
      "edit": "Edit",
      "view": "View",
      "insert": "Insert",
      "format": "Format",
      "tools": "Tools",
      "table": "Table",
      "save": "Save",
      "exportHtml": "Export HTML",
      "undo": "Undo",
      "undoShortcut": "Ctrl+Z",
      "redo": "Redo",
      "redoShortcut": "Ctrl+Y",
      "cut": "Cut",
      "cutShortcut": "Ctrl+X",
      "copy": "Copy",
      "copyShortcut": "Ctrl+C",
      "paste": "Paste",
      "pasteShortcut": "Ctrl+V",
      "pasteAsText": "Paste as plain text",
      "selectAll": "Select All",
      "selectAllShortcut": "Ctrl+A",
      "sourceCode": "Source code",
      "preview": "Preview",
      "fullscreen": "Fullscreen",
      "fullscreenShortcut": "Ctrl+Shift+F",
      "image": "Image",
      "link": "Link",
      "linkShortcut": "Ctrl+K",
      "insertTable": "Table",
      "horizontalRule": "Horizontal line",
      "bold": "Bold",
      "boldShortcut": "Ctrl+B",
      "italic": "Italic",
      "italicShortcut": "Ctrl+I",
      "underline": "Underline",
      "underlineShortcut": "Ctrl+U",
      "strike": "Strikethrough",
      "superscript": "Superscript",
      "subscript": "Subscript",
      "code": "Code",
      "wrap": "Block",
      "align": "Align",
      "clearFormatting": "Clear formatting",
      "paragraph": "Paragraph",
      "heading1": "Heading 1",
      "heading2": "Heading 2",
      "heading3": "Heading 3",
      "blockquote": "Blockquote",
      "codeBlock": "Code block",
      "taskList": "Task list",
      "alignLeft": "Left",
      "alignCenter": "Center",
      "alignRight": "Right",
      "alignJustify": "Justify",
      "tableProperties": "Table properties",
      "deleteTable": "Delete table",
      "row": "Row",
      "column": "Column",
      "cell": "Cell",
      "addRowBefore": "Insert row above",
      "addRowAfter": "Insert row below",
      "deleteRow": "Delete row",
      "addColumnBefore": "Insert column left",
      "addColumnAfter": "Insert column right",
      "deleteColumn": "Delete column",
      "mergeCells": "Merge cells",
      "splitCell": "Split cell",
      "imageUpload": "Upload Image",
      "formFields": "Form Fields",
      "formCheckbox": "Form Checkbox",
      "formRadio": "Form Radio Button",
      "applySource": "Apply",
      "closeDialog": "Close",
      "copyHtml": "Copy HTML",
      "exportDefault": "Export HTML",
      "previewEmpty": "Nothing to preview.",
      "sourceCodeHint": "Edit HTML directly and click Apply to update the editor."
    }
  }
}
